/** Shared polling interval for cross-role views (AM/client dashboards, campaign content). */
export const SHARED_QUERY_REFETCH_MS = 25_000
